<template>
  <b-modal :id="modalId" centered size="sm" hide-header @ok="takeAction()"
           @hidden="ko()" @show="show">
    <div class="d-block text-center">
      <Icon name="grAnonymize" width="36" class="mb-3"/>
      <h1 class="modal-title">
        <template v-if="checkinAnonymizeStatus===ANONYMIZATION_STATUS.available">
          {{ $t('modal_anonymize_checkin.title') }}
        </template>
        <template v-if="checkinAnonymizeStatus===ANONYMIZATION_STATUS.completed">
          {{ $t('modal_deanonymize_checkin.title') }}
        </template>
      </h1>
      <p class="py-2 px-4 text-secondary m-0"
         v-html="$t('modal_anonymize_checkin.txt', {'eventName': checkinEventName})"></p>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <div class="w-100">
        <div class="d-sm-flex justify-content-center">
          <div class="flex-grow-1 order-sm-1 ml-sm-2 mb-2 mb-sm-0">
            <button-with-spinner class="btn btn-primary btn-block" @click="ok" :loading="loading">
              <template v-if="checkinAnonymizeStatus===ANONYMIZATION_STATUS.available">
                {{ $t('modal_anonymize_checkin.btn_ok') }}
              </template>
              <template v-if="checkinAnonymizeStatus===ANONYMIZATION_STATUS.completed">
                {{ $t('modal_deanonymize_checkin.btn_ok') }}
              </template>
            </button-with-spinner>
          </div>
          <div class="flex-grow-1 order-sm-0 mr-sm-2">
            <b-button variant="light" block @click="cancel()">
              {{ $t('modal_anonymize_checkin.btn_cancel') }}
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>


<script>
import ButtonWithSpinner from '@/components/ButtonWithSpinner'
import EventService from "@/services/Event"
import metric_message from "@/domain/metrics/message";

export const ANONYMIZATION_STATUS = {
  unavailable: 'unavailable',
  available: 'available',
  completed: 'completed',
  pending: 'pending'
}

export const ANONYMIZATION_MODE = {
  deep: 'deep',
  blur: 'blur',
}
export default {
  components: {
    ButtonWithSpinner,
  },

  props: {
    modalId: {
      type: String,
      required: false,
      default: 'modal-anonymize-checkin'
    },
    checkinId: {
      type: Number,
      required: true
    },

    checkinEventName: {
      type: String,
      required: true
    },
    checkinAnonymizeStatus: {
      type: String,
      required: true
    },
    checkinAnonymizeMode: {
      type: String,
      required: true,
    }
  },
  computed: {
    anonymizeOnToastMessage() {
      return this.checkinAnonymizeMode === this.ANONYMIZATION_MODE.blur ? 'modal_anonymize_checkin.toast_anonymization_started_blur' : 'modal_anonymize_checkin.toast_anonymization_started_deep'
    },
  },
  created() {
    this.ANONYMIZATION_STATUS = ANONYMIZATION_STATUS
    this.ANONYMIZATION_MODE = ANONYMIZATION_MODE
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    show() {
      this.loading = false
    },
    ko() {
      this.$emit('anonymize-closed')
    },
    takeAction() {
      this.checkinAnonymizeStatus === this.ANONYMIZATION_STATUS.completed ? this.deAnonymizeAlbum() : this.anonymizeAlbum()
    },
    anonymizeAlbum() {
      this.loading = true
      EventService.anonymizeAlbum(this.checkinId).then((response) => {
        this.$bvModal.hide(this.modalId)

        this.$bvToast.toast(
            this.$t(this.anonymizeOnToastMessage),
            {variant: 'success', autoHideDelay: 8000})

        this.$emit('anonymize-call-back', {
          anonymizeStatus: response.data.anonymize_status,
          checkinFaceMissing: false,
        })

      }).catch(error => {
        if (error.response.status === 400 && error.response.data.code === 'checkin_face_missing') {
          this.$emit('anonymize-call-back', {
            anonymizeStatus: error.data.anonymize_status,
            checkinFaceMissing: true
          })
        }
      }).finally(() => {
        metric_message.anonymizedInteraction(this.checkinId)
        this.loading = false
      })
    },
    deAnonymizeAlbum() {
      this.loading = true
      EventService.deAnonymizeAlbum(this.checkinId).then((response) => {
        this.$bvModal.hide(this.modalId)
        this.$bvToast.toast(
            this.$t('modal_deanonymize_checkin.toast_anonymization_started'),
            {variant: 'success', autoHideDelay: 8000})
        this.$emit('anonymize-call-back', {
          anonymizeStatus: response.data.anonymize_status,
          checkinFaceMissing: false,
        })
      }).finally(() => {
        metric_message.anonymizedInteraction(this.checkinId)
        this.loading = false
      })
    }
  }

}
</script>
